import { IUser } from '../../modules/Auth/models/user.model';
import env from '../env';

export const loadScriptKira = (user: IUser) => {
  try {
    const script = document.createElement('script');
    script.src = `${env.REACT_APP_KIRA_WIDGET_URL}?${Math.random()}`;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      if (window.initKiraWidget) {
        window.initKiraWidget({
          user: {
            id: user.id,
            name: user.name,
          },
          levelId: env.REACT_APP_KIRA_LEVEL_ID,
        });
      } else {
        console.error('Função initKiraWidget não encontrada no window');
      }
    };
    script.onerror = () => {
      console.error('Erro ao carregar o script', script.src);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  } catch (e) {
    console.log('Error kira', e);
  }
};
